import ProductGallery from "./ProductGallery";
import { PageMeta, BreadcrumbJsonLd } from "../seo";

function ProductPage() {
  return (
    <>
      <PageMeta
        title="零售及批發產品"
        description="頂級馬來西亞D197貓山王、D200黑刺榴槤鮮果、急凍產品批發零售｜香港供應。"
        canonicalPath="/product"
      />
      <BreadcrumbJsonLd
        items={[
          { name: "首頁", path: "/" },
          { name: "產品", path: "/product" },
        ]}
      />
      <ProductGallery />
    </>
  );
}
export default ProductPage;